// extracted by mini-css-extract-plugin
module.exports = {"orders":"styles_orders__3zYAJ"};